import { MixtureTypeDto } from '../mixturetypes/mixturetype';
import { ParameterSetDto } from '../parametersets/parameterset';
import { ProductDto } from '../products/product';
import { ProductParameterDetailDto } from '../products/productParameter';
import { SpecificationDto } from '../specifications/specification';
import { UserDto } from '../users/user';

interface MixtureBaseDto {
  no?: number;
  mixDate?: Date;
  description?: string;
  totalNumber?: number;
  totalAmount?: number;
  mixtureStatusId?: number;
  mixtureTypeId?: number;
  parameterSetId?: number;
  specificationId?: number;
  productId?: number;
  currentNumber?: number;
  currentAmount?: number;
}

export interface MixtureDto extends MixtureBaseDto {
  id?: number;
  mixtureTypeName: string;
  mixtureStatusName: string;
  specificationNo: string;
  specificationName: string;
  runNo?: number;
  lotNo?: number;
  runSystemName: string;
  gradeName: string;
}

export interface MixtureDetailDto extends MixtureBaseDto {
  id?: number;
  mixtureStatus: MixtureStatusDto;
  mixtureType: MixtureTypeDto;
  specification: SpecificationDto;
  product: Nullable<ProductDto>;
  parameterSet: Nullable<ParameterSetDto>;
  mixtureProducts: MixtureProductDto[];
  userId?: number;
  user: Nullable<UserDto>;
}

export interface MixtureEditDto extends MixtureBaseDto {
  id?: number;
  userId?: number;
  mixtureProducts?: MixtureProductDto[];
}

export interface MixtureStatusDto {
  id: number;
  name: string;
}

export interface MixtureProductDto {
  id?: number;
  mixtureId?: number;
  productId: number;
  amount: number;
  userId: number;
  mixDate?: Date;
  mixtureNo: number;
  runNo: number;
  runDate?: Date;
  lotNo?: number;
  runSystemName: string;
  gradeName: string;
  totalNumber?: number;
  totalAmount?: number;
  userInitials: string;

  parameters: ProductParameterDetailDto[];
}

export interface MixtureAvgParameterDto {
  parameterId: number;
  parameterName: string;
  methodId: number;
  methodName: string;
  avgParameterValue?: number;
  acceptedForProduction: boolean;
  acceptedForCustomer: boolean;
}

export interface MixtureStdPracticeDto {
  parameterId: number;
  parameterName: string;
  minValue?: number;
  maxValue?: number;
}

export interface MixtureSpecificationDto {
  parameterId: number;
  parameterName: string;
  methodId: number;
  methodName: string;
  minProd: number;
  maxProd: number;
  minCustomer: number;
  maxCustomer: number;
}

export enum MixtureStatus {
  Ongoing = 1,
  Finished = 2
}
